// eslint-disable-next-line import/prefer-default-export
export const EmployeeSubmissionTimeUnit = Object.freeze({
    Minute: 0,
    Hour: 1,
});
